import { logger } from '@gem/modules/logger';

import { IUserDeviceKeyPackage } from 'APP/model/e2ee/e2eeModel.types';
import { e2eeModel } from 'APP/model/model';
import { MlsStorageService } from 'SERVICES/mlsStorageService/MlsStorageService';

import { getCommitMessages } from './getCommitMessages';

export const addTrustedDevicesToSecretGroup = async (
  groupId: string,
  keyPackage: IUserDeviceKeyPackage,
  retry?: boolean
): Promise<{ error: string | null }> => {
  try {
    const mlsGroup = MlsStorageService.loadGroup(groupId);

    if (!mlsGroup) {
      throw new Error('MlsGroup does not exist');
    }

    const addMembersResult = MlsStorageService.addMembersToGroup([keyPackage], mlsGroup);

    const response = await e2eeModel.createSecretGroupCommit({
      participantsWelcomeMessages: addMembersResult.welcomeMessages,
      commit: addMembersResult.commit,
      epoch: addMembersResult.epoch,
      groupId,
    });

    if (response.needToSyncCommits && !retry) {
      await getCommitMessages(groupId, Number(mlsGroup.currentEpoch()));
      return await addTrustedDevicesToSecretGroup(groupId, keyPackage, true);
    } else {
      MlsStorageService.processMyWelcomeCommit(addMembersResult.welcomeCommit, mlsGroup);
    }

    return { error: null };
  } catch (error) {
    logger.get('Tasks').error('e2ee.addTrustedDevicesToSecretGroup', error);
    return { error: error.message };
  }
};
